import { jsx as _jsx } from "react/jsx-runtime";
import { TextInput, useIsInputFocused } from '@bos/ui';
import { removeWhitespaceCharacters } from '@bos/utils';
import { getNumber } from '@pbk/get-number';
import { composeMoney } from '@pbk/utils';
import { useState } from 'react';
import { useController } from 'react-hook-form';
import { extractNumberWithWhitespace } from '../helpers/extractNumberWithWhitespace';
export const MoneyField = ({ control, name, registerOptions, roundOutput, currency = 'CZK', locale, minimumFractionDigits, maximumFractionDigits, submitOnEnter = false, ...props }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const [editValue, setEditValue] = useState('');
    const composeFieldValueIntoMoney = (withCurrency) => {
        if (typeof field.value !== 'number')
            return '';
        return composeMoney({
            money: {
                amount: getNumber(field.value),
                currency: withCurrency ? currency : undefined,
            },
            locale,
            minimumFractionDigits,
            maximumFractionDigits,
        });
    };
    const formatFieldToDisplayValue = () => composeFieldValueIntoMoney(true);
    const formatFieldToEditValue = () => composeFieldValueIntoMoney(false);
    const { isFocused, handleFocus, handleBlur } = useIsInputFocused({
        disabled: props.disabled,
        readOnly: props.readOnly,
        onFocus: () => {
            setEditValue(formatFieldToEditValue());
        },
        onBlur: () => {
            field.onBlur();
            setEditValue(formatFieldToEditValue());
        },
    });
    const handleChange = (e) => {
        const newValue = extractNumberWithWhitespace(e.target.value, {
            allowDecimalPoint: !roundOutput,
        });
        if (!newValue || newValue.length <= 0) {
            field.onChange(null);
            setEditValue('');
            return;
        }
        setEditValue(newValue);
        const cleanValue = removeWhitespaceCharacters(newValue);
        const num = getNumber(cleanValue);
        field.onChange((roundOutput ? Math.round(num) : num));
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Escape') {
            if (!submitOnEnter)
                e.currentTarget.blur();
        }
    };
    const displayValue = isFocused ? editValue : formatFieldToDisplayValue();
    return (_jsx(TextInput, { ...props, ref: field.ref, name: field.name, error: fieldState.error?.message, value: displayValue, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyDown: handleKeyDown }));
};
